import { type ChangeEvent, useCallback, useEffect, useState } from "react";

import { PageNavigation } from "~/components/PageNavigation";
import { listAdmins } from "~/modules/admin/services";
import type { AdminQuery, ListAdminsDTO } from "~/modules/admin/types";
import { debouncer } from "~/utils/debounce";

import { AdminCard } from "./components/AdminCard";
import { Header } from "./components/Header";
import { managersContext } from "./context/index";

const debounce = debouncer();

export function Administrators() {
	const [filter, setFilter] = useState<AdminQuery>({
		limit: 10,
		page: 0,
	});
	const [data, setData] = useState<ListAdminsDTO>();

	const handleIncrementPage = useCallback((page: number) => {
		setFilter((state) => ({ ...state, page }));
	}, []);

	const handleUpdateQuery = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		debounce(() => {
			setFilter({
				limit: 10,
				page: 0,
				query: e.target.value,
			});
		});
	}, []);

	const handleResetList = useCallback(() => {
		setFilter({
			limit: 10,
			page: 0,
			query: "",
		});
	}, []);

	useEffect(() => {
		console.log("filter update");
		const controller = new AbortController();
		listAdmins(filter, controller.signal).then((res) => {
			if (res) {
				setData(res);
			}
		});
		return () => {
			controller.abort();
		};
	}, [filter]);

	return (
		<managersContext.Provider value={{ handleUpdateQuery, handleResetList }}>
			<div className="flex flex-col flex-1 overflow-y-hidden bg-slate-100">
				<Header />

				<div className="flex flex-col p-5 flex-1">
					<div className="flex-1">
						<div
							className="grid gap-4
                grid-cols-[repeat(auto-fill,minmax(230px,1fr))]"
						>
							{data?.admins.map((admin, index) => (
								<AdminCard key={`admin-${index}`} data={admin} />
							))}
						</div>
					</div>

					<div className="flex justify-end">
						<PageNavigation
							currentPage={filter.page ?? 0}
							numPages={data?.meta.totalPages ?? 0}
							onPageChange={handleIncrementPage}
						/>
					</div>
				</div>
			</div>
		</managersContext.Provider>
	);
}
